import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization/localize";
import { Button } from "@faire/web--source/slate/Button";
import { LocationDynamic } from "@faire/web--source/slate/icons/Location";
import DropdownList from "@faire/web--source/slate/Input/DropdownList";
import { Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";
export var CustomAddressDropdown = function(_param) {
    var className = _param.className, children = _param.children, open = _param.open, onOpen = _param.onOpen, onClose = _param.onClose, options = _param.options, onCannotFindClick = _param.onCannotFindClick, showCannotFindOption = _param.showCannotFindOption, props = _object_without_properties(_param, [
        "className",
        "children",
        "open",
        "onOpen",
        "onClose",
        "options",
        "onCannotFindClick",
        "showCannotFindOption"
    ]);
    var slicedOptions = (options !== null && options !== void 0 ? options : []).slice(0, 4);
    var customOptions = showCannotFindOption ? [
        {
            id: CANT_FIND_OPTION_ID
        }
    ] : [];
    var dropdownOptions = _to_consumable_array(slicedOptions).concat(_to_consumable_array(customOptions));
    var onSelect = function(value) {
        if (value === CANT_FIND_OPTION_ID) {
            onCannotFindClick();
            return;
        }
        var selectedOption = options.find(function(option) {
            return option.id === value;
        });
        if (selectedOption) {
            props.onSelect(selectedOption);
        }
    };
    var renderOption = function(option, onSelect, onMouseOver, selectedValue) {
        return /*#__PURE__*/ _jsx(Option, _object_spread_props(_object_spread({}, option), {
            onSelect: onSelect,
            onMouseOver: onMouseOver,
            selectedValue: selectedValue,
            onCannotFindClick: onCannotFindClick
        }), option.id);
    };
    return /*#__PURE__*/ _jsx(DropdownList, {
        classNameDropdown: className,
        open: open,
        onOpen: onOpen,
        onClose: onClose,
        getLabel: getLabel,
        getValue: getValue,
        options: dropdownOptions,
        renderOption: renderOption,
        onSelect: onSelect,
        appendage: Appendage,
        children: children
    });
};
var Option = function(param) {
    var id = param.id, name = param.name, location = param.location, onSelect = param.onSelect, onMouseOver = param.onMouseOver, selectedValue = param.selectedValue, onCannotFindClick = param.onCannotFindClick;
    return id !== CANT_FIND_OPTION_ID ? /*#__PURE__*/ _jsxs(DropdownButton, {
        type: "button",
        $selected: selectedValue === id,
        onClick: onSelect,
        onMouseOver: onMouseOver,
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                size: "1x"
            }),
            /*#__PURE__*/ _jsx(LocationDynamic, {
                height: "12px",
                solid: true,
                color: Core.icon.subdued
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "1x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "labelSansRegular",
                children: name
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "1x"
            }),
            /*#__PURE__*/ _jsx(EndingEllipsis, {
                children: location
            })
        ]
    }, id) : /*#__PURE__*/ _jsx(FooterButton, {
        type: "button",
        onMouseOver: onMouseOver,
        $selected: selectedValue === id,
        onClick: onCannotFindClick,
        children: /*#__PURE__*/ _jsx(Typography, {
            variant: "labelSansRegular",
            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "+8qWs4",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Can't find your address? "
                    },
                    {
                        type: 8,
                        value: "LinkFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Click Here"
                            }
                        ]
                    }
                ],
                values: {
                    LinkFormatting: CantFindAddressLink
                }
            })
        })
    }, "footer-button");
};
var getValue = function(param) {
    var id = param.id;
    return id;
};
var getLabel = function(param) {
    var name = param.name, location = param.location;
    return "".concat(name, " ").concat(location);
};
var CantFindAddressLink = function(chunks) {
    return /*#__PURE__*/ _jsx(Button, {
        type: "button",
        variant: "tertiary",
        "data-test-id": "can-not-find-address-button",
        children: chunks
    });
};
var GoogleMaps = styled.img.withConfig({
    componentId: "sc-a049ccc4-0"
})([
    "width:75px;height:auto;position:relative;top:4px;"
]);
var PoweredBy = styled(Row).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-a049ccc4-1"
})([
    "width:100%;height:30px;padding:0 14px;"
]);
var Appendage = /*#__PURE__*/ _jsx(PoweredBy, {
    children: /*#__PURE__*/ _jsx(Typography, {
        variant: "labelSansRegular",
        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "HSG+yb",
            defaultMessage: [
                {
                    type: 0,
                    value: "Powered By "
                },
                {
                    type: 1,
                    value: "logo"
                }
            ],
            values: DEPRECATED_backwardsCompatibleValues({
                logo: /*#__PURE__*/ _jsx(GoogleMaps, {
                    src: "https://cdn.faire.com/fastly/f98d8a1a357fa91b88ee5b67c51ed3de79f4ae19cb8f8b6f1a7b45af18a61691.png"
                })
            })
        })
    })
});
var CANT_FIND_OPTION_ID = "cantfind";
var EndingEllipsis = styled(Typography).attrs({
    color: Core.text.subdued,
    variant: "labelSansRegular"
}).withConfig({
    componentId: "sc-a049ccc4-2"
})([
    "overflow:hidden;text-overflow:ellipsis;"
]);
var DropdownButton = styled(Row).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-a049ccc4-3"
})([
    "cursor:pointer;width:100%;height:40px;background-color:",
    ";outline:0;border:0;overflow:hidden;white-space:nowrap;"
], function(props) {
    return props.$selected ? Core.surface.subdued : "unset";
});
var FooterButton = styled(DropdownButton).withConfig({
    componentId: "sc-a049ccc4-4"
})([
    "padding:0 16px;height:42px;border-top:1px solid ",
    ";border-bottom:1px solid ",
    ";"
], Core.surface.subdued, Core.surface.subdued);
